module.exports = "<p>\n  user-edit works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-customers/user-edit/user-edit.component.html
// module id = ./src/app/components/admin/admin-customers/user-edit/user-edit.component.html
// module chunks = main